<div class="component">

    <app-buttons  (open)="openPanel()" [buttonsWrap]="'add'" [addbut]="addbut"></app-buttons>

    <app-filter [tableName]="'tipobono'"></app-filter>

</div>

<app-table [tableName]="'tipobono'" (addbut)="addbut=$event"></app-table>

<app-panelcustoman
*ngIf="customanpanel!==undefined" 
[ConfigPanel]="customanpanel"
[mode]="'I'" >
</app-panelcustoman> 



